import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import _ from 'lodash'
import 'react-dates/lib/css/_datepicker.css'

moment.locale('pt-br')

class DatePicker extends Component {
  state = {
    focused: false,
  }

  handleChange = (value) => {
    const { onDateChange, onChange } = this.props

    if (onChange) {
      return onChange({
        target: { value },
      })
    }

    if (onDateChange) {
      onDateChange(value)
    }
  }

  handleFocusChange = (data) => {
    const { onFocusChange, scrollIntoView } = this.props

    if (data.focused && scrollIntoView) {
      const input = ReactDOM.findDOMNode(this.refs.myRef)

      setTimeout(() => {
        input.scrollIntoView({ behavior: 'smooth' })
      }, 100)
    }

    if (onFocusChange) {
      return onFocusChange(data)
    }

    this.setState({ focused: data.focused })
  }

  isFocused = () => {
    const { focused } = this.props
    return _.isNil(focused) ? this.state.focused : focused
  }

  isOutsideRange = () => {
    const { isOutsideRange } = this.props

    if (_.isFunction(isOutsideRange)) {
      return isOutsideRange
    }

    return isOutsideRange && (() => false)
  }

  render() {
    const {
      date,
      value,
      placeholder,
      disabled,
      showClearDate,
      id,
      openUp = 'down',
    } = this.props

    return (
      <SingleDatePicker
        ref={'myRef'}
        placeholder={placeholder}
        date={date || value || null}
        focused={this.isFocused()}
        onDateChange={this.handleChange}
        onFocusChange={this.handleFocusChange}
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        displayFormat={() => moment.localeData('pt-br').longDateFormat('L')}
        monthFormat='MMMM YYYY'
        readOnly
        disabled={disabled}
        showClearDate={showClearDate}
        isOutsideRange={this.isOutsideRange()}
        id={id}
        openDirection={openUp}
      />
    )
  }
}

DatePicker.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  isOutsideRange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onDateChange: PropTypes.func,
  onChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  placeholder: PropTypes.string,
  showClearDate: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  scrollIntoView: PropTypes.bool.isRequired,
  openUp: PropTypes.string,
}

DatePicker.defaultProps = {
  scrollIntoView: true,
}

export default DatePicker
